// extracted by mini-css-extract-plugin
export default {"panel":"tSHvu1z2mla91xTC0L8w"};